import { isNumeric } from '../../util/helpers';

import { LatLon } from '../../util/geodesy/latlon';
import { parseLatLon } from '../../airport/util/parseUtils';
import { convert, FEET, METERS } from '../../util/units';
import { Forecast } from './forecast.model';


/**
 * TAF model (Terminal Aerodrome Forecast)
 */
export class Taf {
  /**
   * Station identifier (typically the ICAO identifier of the corresponding airport)
   */
  stationId: string;

  /**
   * Station latitude and longitude
   */
  location: LatLon;

  /**
   * Station elevation in meters
   */
  elevation: number;

  /**
   * Issue time of the forecast
   */
  issueTime: Date;

  /**
   * Start time when the TAF is valid
   */
  validFrom: Date;

  /**
   * End time when the TAF is valid
   */
  validTo: Date;

  /**
   * Array of individual forecast periods within this TAF
   */
  forecasts: Array<Forecast>;

  /**
   * TAF raw text
   */
  rawText: string;

  /**
   * Parses a TAF from the API
   * @param data
   * @returns {Taf}
   */
  static parse(data: any): Taf {
    return {
      stationId: data.icao_code,
      location: parseLatLon(data.latitude, data.longitude),
      elevation: isNumeric(data.elevation_m) ? convert(data.elevation_m, METERS, FEET) : null,
      issueTime: data.issue_time ? new Date(data.issue_time) : null,
      validFrom: data.valid_time_from ? new Date(data.valid_time_from) : null,
      validTo: data.valid_time_to ? new Date(data.valid_time_to) : null,
      forecasts: (data.forecasts || []).map(Forecast.parse),
      rawText: data.raw_text || null,
    };
  }
}
